import { combineReducers } from 'redux';

import {
  FETCH_USER_FLAGS_SUCCESS,
  USER_FLAG_UPDATED,
} from 'actions/featureFlags';

export function flags(state = {}, action) {
  switch (action.type) {
    case FETCH_USER_FLAGS_SUCCESS:
      return {
        ...state,
        ...action.flags,
      };
    case USER_FLAG_UPDATED:
      return {
        ...state,
        [action.flag]: action.value,
      };
    default:
      return state;
  }
}

export function loaded(state = false, action) {
  switch (action.type) {
    case FETCH_USER_FLAGS_SUCCESS:
      return true;
    default:
      return state;
  }
}

export default combineReducers({
  flags,
  loaded,
});



// WEBPACK FOOTER //
// ./src/reducers/featureFlags.js